var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5674 20C16.0902 20 20.5674 15.5228 20.5674 10C20.5674 4.47715 16.0902 0 10.5674 0C5.04454 0 0.567383 4.47715 0.567383 10C0.567383 15.5228 5.04454 20 10.5674 20ZM11.8174 7.70937L14.9061 12.8562C15.6136 14.0356 15.0674 15 13.6924 15H7.44238C6.06738 15 5.52113 14.035 6.22863 12.8562L9.31738 7.70937V5.625H9.00488C8.83301 5.625 8.69238 5.48438 8.69238 5.3125C8.69238 5.14062 8.83301 5 9.00488 5H12.1299C12.3018 5 12.4424 5.14062 12.4424 5.3125C12.4424 5.48438 12.3018 5.625 12.1299 5.625H11.8174V7.70937ZM9.94238 7.88125L7.92113 11.25H13.2136L11.1924 7.88125V5.625H9.94238V7.88125Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTest);
export default __webpack_public_path__ + "static/media/test.88e652c2e2a15aa503aea3dd2bb758f6.svg";
export { ForwardRef as ReactComponent };